export const ENROLLMENT_PENDING = 'ENROLLMENT_PENDING';

export const enrollmentPending = () => dispatch =>
  dispatch({
    type: ENROLLMENT_PENDING,
  });
